import type { UnlockCondition } from '@/api/learnerGames'

export type TFunction = (key: string, vars?: Record<string, unknown>) => string

/**
 * Spec §8 i18n format: "{curriculum} 챕터 {chapter} 레슨 {lesson} {lessonTitle}"
 * ALWAYS unlock → empty string. lessonTitle 없으면 trailing whitespace trim.
 *
 * Phase B: 백엔드에 커리큘럼 코드(CORE_A 등)가 없어 curriculum은 옵셔널.
 * curriculum 없으면 lessonTitle 우선, 없으면 "챕터 {chapter} 레슨 {lesson}".
 */
export function formatUnlockHint(cond: UnlockCondition, t: TFunction): string {
  if (cond.type === 'ALWAYS') return ''
  const lessonTitle = cond.lessonTitle ?? ''
  if (cond.curriculum) {
    const curriculum = t(`playground.curriculum.${cond.curriculum}`)
    return t('playground.lockedHint.format', {
      curriculum,
      chapter: cond.chapter,
      lesson: cond.lesson,
      lessonTitle,
    }).replace(/\s+$/, '')
  }
  if (lessonTitle) return lessonTitle
  return t('playground.lockedHint.noCurriculum', {
    chapter: cond.chapter,
    lesson: cond.lesson,
  }).replace(/\s+$/, '')
}
